// extracted by mini-css-extract-plugin
export default {"column":"DevicesRow__column-b2NEn","row":"DevicesRow__row-qHOeP","label":"DevicesRow__label-xCdgT","targetName":"DevicesRow__targetName-uU6dA"};